<div class="min-vh-100 bg-white side-bar mobile" id="div_min-vh-100_d5eb79e4">
  <ul class="nav nav-tabs flex-column" id="ul_nav_f8d4de07">
    <li class="sidebar-title nav-item" id="li_sidebar-title_97720d22">
      <a aria-label="REQUEST A QUOTE" title="REQUEST A QUOTE" id="a_f67134c7"
        >REQUEST A QUOTE</a
      >
      <!-- <div class="back-button" (click)="showBackModal()">
        <span class="back-button-text">Back to search</span>
      </div> -->
    </li>

    <li class="nav-item" id="li_nav-item_55159de5">
      <a
        aria-label="Your Selections"
        title="Your Selections"
        class="nav-link"
        [class.done]="currentStep !== enum_request_steps.SELECTION"
        [ngClass]="currentStep === enum_request_steps.SELECTION ? 'active' : ''"
        (click)="goToStep(enum_request_steps.SELECTION)"
        id="a_nav-link_06da3285"
        >Your Selections</a
      >
    </li>
    <li
      class="nav-item"
      *ngIf="
        selectedCarType != enum_car_type.GONDOLA &&
        selectedCarType != enum_car_type.OPEN_HOPPER
      "
      id="li_nav-item_ac2531fd"
    >
      <a
        aria-label="Mechanical Options"
        title="Mechanical Options"
        class="nav-link"
        [class.done]="
          currentStep !== enum_request_steps.MECHANICAL_OPTIONS &&
          quoteRequestService.isValidStep(enum_request_steps.MECHANICAL_OPTIONS)
        "
        [ngClass]="
          currentStep === enum_request_steps.MECHANICAL_OPTIONS ? 'active' : ''
        "
        (click)="goToStep(enum_request_steps.MECHANICAL_OPTIONS)"
        id="a_nav-link_03d44454"
      >
        Mechanical Options</a
      >
    </li>
    <li class="nav-item" id="li_nav-item_c7a2ba05">
      <a
        aria-label="Lease Details"
        title="Lease Details"
        class="nav-link"
        [class.done]="
          currentStep !== enum_request_steps.LEASING_OPTIONS &&
          quoteRequestService.isValidStep(enum_request_steps.LEASING_OPTIONS)
        "
        [ngClass]="
          currentStep === enum_request_steps.LEASING_OPTIONS ? 'active' : ''
        "
        (click)="goToStep(enum_request_steps.LEASING_OPTIONS)"
        id="a_nav-link_28a9a93f"
        >Lease Details</a
      >
    </li>
    <li class="nav-item" id="li_nav-item_abdee558">
      <a
        aria-label="Review and submit"
        title="Review and submit"
        class="nav-link"
        [ngClass]="currentStep === enum_request_steps.REVIEW ? 'active' : ''"
        (click)="goToStep(enum_request_steps.REVIEW)"
        id="a_nav-link_da1808b3"
        >Review & Submit</a
      >
    </li>
  </ul>
</div>

<div
  class="w-100 d-flex flex-column justify-content-center mb-5 mobile-nav-bar"
  id="div_w-100_3478aaca"
>
  <div class="d-flex sidebar-title-mob mt-4" id="div_d-flex_651c5a9d">
    <a aria-label="REQUEST A QUOTE" title="REQUEST A QUOTE" id="a_4f784be1"
      >REQUEST A QUOTE</a
    >
  </div>

  <div id="div_468884df">
    <div class="d-flex nav-mobile" id="div_d-flex_87edac74">
      <div class="border-mid" id="div_border-mid_12902faf"></div>
      <div class="main-circle" id="div_main-circle_12499005">
        <a
          aria-label="  Your Selections"
          title="  Your Selections"
          (click)="goToStep(enum_request_steps.SELECTION)"
          [class.done]="currentStep !== enum_request_steps.SELECTION"
          [ngClass]="
            currentStep === enum_request_steps.SELECTION ? 'active' : ''
          "
          class="circle"
          id="a_circle_48d16ab9"
          ><p
            aria-label="Your Selections"
            title="Your Selections"
            class="text-nav"
            id="p_text-nav_44115a3a"
          >
            Your Selections
          </p></a
        >
      </div>
      <div class="border-mid" id="div_border-mid_c4c6ab32"></div>
      <div
        class="main-circle"
        *ngIf="
          selectedCarType != enum_car_type.GONDOLA &&
          selectedCarType != enum_car_type.OPEN_HOPPER
        "
        id="div_main-circle_d394bd27"
      >
        <a
          aria-label="mechanical operations"
          title="mechanical operations"
          [class.done]="
            currentStep !== enum_request_steps.MECHANICAL_OPTIONS &&
            quoteRequestService.isValidStep(
              enum_request_steps.MECHANICAL_OPTIONS
            )
          "
          [ngClass]="
            currentStep === enum_request_steps.MECHANICAL_OPTIONS
              ? 'active'
              : ''
          "
          (click)="goToStep(enum_request_steps.MECHANICAL_OPTIONS)"
          class="circle"
          id="a_circle_65edfb0f"
          ><p
            aria-label="mechanical operations"
            title="mechanical operations"
            class="text-nav"
            id="p_text-nav_fdb27a97"
          >
            mechanical operations
          </p></a
        >
      </div>
      <div class="border-mid" id="div_border-mid_4b077815"></div>
      <div class="main-circle" id="div_main-circle_2dad9bb3">
        <a
          aria-label="lease details"
          title="lease details"
          [class.done]="
            currentStep !== enum_request_steps.LEASING_OPTIONS &&
            quoteRequestService.isValidStep(enum_request_steps.LEASING_OPTIONS)
          "
          [ngClass]="
            currentStep === enum_request_steps.LEASING_OPTIONS ? 'active' : ''
          "
          (click)="goToStep(enum_request_steps.LEASING_OPTIONS)"
          class="circle"
          id="a_circle_85834a04"
          ><p
            aria-label="lease details"
            title="lease details"
            class="text-nav"
            id="p_text-nav_60046ea7"
          >
            lease details
          </p></a
        >
      </div>
      <div class="border-mid" id="div_border-mid_373a8d6f"></div>
      <div class="main-circle" id="div_main-circle_081e55bb">
        <a
          aria-label="review and submit"
          title="review and submit"
          [ngClass]="currentStep === enum_request_steps.REVIEW ? 'active' : ''"
          (click)="goToStep(enum_request_steps.REVIEW)"
          class="circle"
          id="a_circle_abc10784"
          ><p
            aria-label="review & submit"
            title="review & submit"
            class="text-nav"
            id="p_text-nav_c2ca2d74"
          >
            review & submit
          </p></a
        >
      </div>
      <div class="border-mid" id="div_border-mid_f254eea6"></div>
    </div>
  </div>
</div>

<!-- Modal -->
<p-dialog
  #returnSearch=""
  [(visible)]="displayReturnToSearch"
  [modal]="true"
  [style]="{ width: '690px', height: '471px' }"
  [draggable]="false"
  [resizable]="false"
  id="p-dialog_30f2edc6"
>
  <div id="div_a35f631f">
    <h4 class="m-title" id="h4_m-title_260344f9">
      Are you sure you want to return to your search?
    </h4>
  </div>
  <p id="p_36486a6b">
    If you change your railcar type or product, any mechanical or lease options
    you may have entered will be cleared.
  </p>
  <a
    aria-label="return to search"
    title="return to search"
    (click)="navigateHome()"
    id="a_33cc2d83"
    >Yes, return to search.</a
  >
</p-dialog>
